import { property, supertypeClass } from '@haventech/amorphic';
import { Everything } from '@hit/amorphic-types';
import { AnnuityPaymentSource } from '../../js/interfaces/CoverpathTypes';
import { AnnuityAttributes } from './AnnuityAttributes';

@supertypeClass({ toClient: true, toServer: true })
export class AnnuitySourcePayment extends Everything {
  @property({
    comment: 'Annuity Attribute to which source payments are attached',
    getType: () => AnnuityAttributes,
  })
  annuityAttributes: AnnuityAttributes;

  @property({
    comment: 'Annuity Payment Source Option',
  })
  source: AnnuityPaymentSource;

  static new(annuityAttributes: AnnuityAttributes) {
    return new AnnuitySourcePayment().init(annuityAttributes);
  }

  init(annuityAttributes: AnnuityAttributes) {
    this.annuityAttributes = annuityAttributes;
    return this;
  }

  constructor() {
    super();
  }
}
